<template>
  <div class="page">
 <studentCard :snCode='$route.query.snCode'  :schoolCode='$route.query.schoolCode'/>
<div class="box">
    <div class="box_title"> 体测成绩</div>
    <div v-for="(item,i) in scoreList" :key="i" class="box_ul">
        <div class="box_li">
             <div >{{item.projectName||''}}<span class="box_li_unit"></span></div>
             <div class="box_li_score">
                <!-- <div v-if="+item.auditStatus==1" class="isAuditStatus">
                  <img src="@/assets/image/待审核.png" alt="" width="50">
                </div> -->
                <div style="width:66%; text-align: right;" >{{item.score||'--'}}{{item.unit}}
                </div>
                <div style="width:17%">
                  <el-button type="text" size="mini" v-if="item.projectCode!=='HeightWeight'"  style="margin:0 10px" @click="onreport(item)">登记</el-button>
               </div>
               <div style="width:17%">
                  <el-button type="text" style="margin:0 10px" size="mini" :disabled='!+item.isHaveScore' @click="onGoDetil(item)">详情</el-button>
               </div>
             </div>
                
             
        </div>
    </div>
</div>


<van-popup   style="height:100%;width: 100%"  v-model:show="showDialog":title="`${reportData.projectName}登记`" :show-confirm-button='false' >
    <van-form @submit="onSubmit" style="margin:20px 0">

        <VfieldRule v-model="score" v-if="reportData.projectName == '身高'" :maxNumber='300'  :precision='1'>
            <template #label>
              <span>成绩({{reportData.unit}})
                <span style="color:red;">*</span>
              </span>
           </template>
         </VfieldRule>
          <VfieldRule v-model="score" v-if="reportData.projectName == '体重'" :maxNumber='300'  :precision='1'>
            <template #label>
              <span>成绩({{reportData.unit}})
                <span style="color:red;">*</span>
              </span>
           </template>
         </VfieldRule>
          <VfieldRule v-model="score" v-if="reportData.projectName == '仰卧起坐'" :maxNumber='999' >
            <template #label>
              <span>成绩({{reportData.unit}})
                <span style="color:red;">*</span>
              </span>
           </template>
         </VfieldRule>
         
          <VfieldRule v-model="score" v-if="reportData.projectName == '跳绳'" :maxNumber='999' >
            <template #label>
              <span>成绩({{reportData.unit}})
                <span style="color:red;">*</span>
              </span>
           </template>
         </VfieldRule>
          <VfieldRule v-model="score" v-if="reportData.projectName == '引体向上'" :maxNumber='999' >
            <template #label>
              <span>成绩({{reportData.unit}})
                <span style="color:red;">*</span>
              </span>
           </template>
         </VfieldRule>
          <VfieldRule v-model="score" v-if="reportData.projectName == '肺活量'" :maxNumber='9999' >
            <template #label>
              <span>成绩({{reportData.unit}})
                <span style="color:red;">*</span>
              </span>
           </template>
         </VfieldRule>
          <VfieldRule v-model="score" v-if="reportData.projectName == '立定跳远'" :maxNumber='360' :precision='1'>
            <template #label>
              <span>成绩({{reportData.unit}})
                <span style="color:red;">*</span>
              </span>
           </template>
         </VfieldRule>
         
         <VfieldRule v-model="score" v-if="reportData.projectName == '50*8往返跑'" :maxNumber='1000' :precision='2'>
            <template #label>
              <span>成绩({{reportData.unit}})
                <span style="color:red;">*</span>
              </span>
           </template>
         </VfieldRule>
          <VfieldRule v-model="score" v-if="reportData.projectName == '50米'" :maxNumber='100' :precision='2'>
            <template #label>
              <span>成绩({{reportData.unit}})
                <span style="color:red;">*</span>
              </span>
           </template>
         </VfieldRule>

        <VfieldRule v-model="score"  v-if="reportData.projectName=='坐位体前屈'" :maxNumber='35'  :precision='1' >
           <template #label>
              <span>成绩({{reportData.unit}})
                <span style="color:red;">*</span>
              </span>
           </template>
            <template #input>
              <van-checkbox v-model="scoreSign" shape="square" >
                <span v-show="!scoreSign">+</span>
                <span v-show="scoreSign">-</span>
              </van-checkbox>
            </template>
         </VfieldRule>



     <van-field name="file"   label="视频" placeholder="请上传视频" style="margin-top:15px;">
        <template #input>
            <PublicUpLoader v-model ="file" @change="changeUpLoader" :item='upLoaderItem'/>
              <!-- <public-uploader v-model:upLoader="file" :item="upLoaderItem" /> -->
          <!-- <van-uploader
            accept='video/*'
            :after-read="afterRead"
            :before-read="beforeRead"
            v-model="file"
          /> -->
          <!-- <van-uploader :after-read="afterRead"   v-model="file"
          accept="avi , flv , mpg , mpeg , mpe , m1v , m2v , mpv2 , mp2v , dat , ts , tp , tpr , pva , pss , mp4 , m4v , m4p , m4b , 3gp , 3gpp , 3g2 , 3gp2 , ogg , mov , qt , amr , rm , ram , rmvb , rpm"
           capture="camera" :max-count="1" :max-size="100 * 1024 * 1024" @oversize="onOversize" /> -->
        </template>
      </van-field>
         <van-sticky :offset-top="'77vh'">
        <div class="buutom">
      <CustomButton  class="button-on" text="返回" @click="showDialog=false" type='2'/>
      <CustomButton  class="button-on" text="确认" native-type="submit" type='1'/>
        </div>
      </van-sticky>

      </van-form>

</van-popup>

  </div>
</template>

<script>
import studentCard from "@/components/studentCard.vue";
import CustomButton from "@/components/CustomButton.vue";
import PublicUpLoader from "@/components/PublicUpLoader.vue";
import VfieldRule from "@/components/VfieldRule.vue";

import { Dialog } from 'vant'
import moment from 'moment'
import { checkOrder,getDelectOrder,orderBySnCode,unOrderBySnCode } from "@/api/appointment.js";
import { getScoreBySnCode,submitScore} from "@/api/resultReporting.js";
import VCellField from "@/components/VCellField";
export default {
  name: 'addTest',
  components: { studentCard,CustomButton,VCellField ,PublicUpLoader,VfieldRule},
  data () {
    return {
      testTips: false,
      scoreSign:false,
      userInfo: {},
      status: {
        1: '已测试',
        2: '已过期',
        3: '未测试'
      },
   
      backgroundColor: {
        1: '#f7b331',
        2: '#ff7079',
        3: '#c7c7c7'
      },
      time: ['上午', '下午', '晚上'],
      auditStatus: ['正常', '有审核中的状态'],
      clickInfo: {},
      scoreList:[],
      showDialog:false,
      reportData:{},
      file:[],
      score:undefined,

      upLoaderItem:{
      type: 'Uploader',
      label: '视频',
      accept: 'video/*',
      disabled: false,
      icon: require('@/assets/appeal/video-icon.png'),
      max: 1,
      upType: 'video', //类型
      name: 'file',
      upName: '添加视频', //自定义名称
      rules: [{ required: true, message: '请添加视频' }],
      },

      // rules:[
      //  { name:'坐位体前屈',:maxNumber='35',:length='2',precision='1',},
      //  { name:'体重',:maxNumber='300',:length='3',precision='1',},
      //  { name:'身高',:maxNumber='300',:length='3',precision='1',},
      //  { name:'仰卧起坐',:maxNumber='999',:length='3',},
      //  { name:'引体向上',:maxNumber='999',:length='3',},
      //  { name:'肺活量',:maxNumber='9999',:length='4',},
      //  { name:'立定跳远',:maxNumber='360',:length='3',},
      //  { name:'50米',:maxNumber='100',:length='2',},
      // ]

    }
  },
  created () {
    this.init()
  },
  methods: {
    // scoreSignChange(){
    // if (!this.scoreSign) {
    //     scoreJSON = 0 - (+scoreJSON)
    // }
    // },
    onGoDetil(item){
      console.log(item);
      this.$router.push({path:'scoreInfo',query:{
            snCode:this.$route.query.snCode,
            schoolCode:this.$route.query.schoolCode,
            termCode:this.$route.query.termCode,
            projectCode:item.projectCode,
      }})
    },
    changeUpLoader(val){
        console.log(val);
    },
    onreport(item){
        this.reportData =item
        this.score = undefined
        this.file = []

        this.showDialog =true
    },
    afterRead(file){
        console.log(1,file);
    },
    onOversize(file){
        console.log(2,file);

    },
    beforeRead(file){
        console.log(2,file);
      return true

    },
    onSubmit(item){

let scoreJSON = JSON.parse(JSON.stringify(this.score))


if (this.reportData.projectName=='坐位体前屈') {
  if (this.scoreSign) {
    scoreJSON = 0 - (+scoreJSON)
  }

}
console.log(this.reportData.projectName!=='坐位体前屈'&&+scoreJSON<=0);
if (this.reportData.projectName!=='坐位体前屈' && +scoreJSON<=0) {
  this.$notify({ type: "danger", message: '成绩数据超出合理范围' });
  return
}
// if (this.file.:length==0) {
//   this.$notify({ type: "danger", message: '请上传视频' });
//   return
// }
 this.$dialog
        .alert({
          message: '是否确认登记?',
          showCancelButton: true
        })
        .then(() => {
            let data
            data = new FormData();
            data.append("snCode", this.$route.query.snCode)
            data.append("schoolCode", this.$route.query.schoolCode)
            data.append("score", scoreJSON)
            data.append("projectCode", this.reportData.projectCode)
            data.append("video", this.file[0]?.file||'')

            submitScore(data).then(Res=>{
            this.$notify({ type: "success", message: '登记成功！' });
            this.init()
            this.showDialog =false
            })
        })
    },
    moment,
    forDetail (item) {
      this.clickInfo = item
      this.testTips = true
    },

    init(){
      this.getScoreBySnCode()

    },
   getScoreBySnCode(){
        getScoreBySnCode({
            snCode:this.$route.query.snCode,
            schoolCode:this.$route.query.schoolCode,
            code:this.$route.query.termCode,
            
          }).then(res=>{
            res.data.data?.forEach(el=>{

            



              switch(el.projectName) {
                case '肺活量': return el.unit= '毫升'
                case '坐位体前屈': return el.unit= '厘米'
                case '跳绳': return el.unit= '个'
                case '仰卧起坐': return el.unit= '个'
                case '体重': return el.unit= '千克'
                case '立定跳远': return el.unit= '厘米'
                case '身高': return el.unit= '厘米'
                case '50*8往返跑': return el.unit= '秒'
                case '身高体重（BMI）': return el.unit= '千克/平方米'
                case '50米': return el.unit= '秒'
                default: return el.unit= ''
                }
            })
            this.scoreList = res.data.data||[]
         
          })
    },
    // getLog () {
    //   getScoreBySnCode({
    //     activityOrder: {
    //       snCode: this.userInfo.snCode
    //     }
    //   }).then(({ data }) => {
    //     this.scoreList = data
    //   })
    // },
    forCancel (item) {
      this.$dialog
        .alert({
          message: '是否确认取消报名?',
          showCancelButton: true
        })
        .then(() => {
            unOrderBySnCode({
                  snCode:this.$route.query.snCode,
            schoolCode:this.$route.query.schoolCode,
                ...item
            }).then(Res=>{
            this.$notify({ type: "success", message: '取消报名成功！' });
            this.init()
            })
        })
       
      
    }
  }
}
</script>

<style lang="less" scoped>
.box{
    background-color: #fff;
    margin: 8px;
    border-radius: 8px;
    padding: 8px 10px;
    .box_title{
      font-weight: 600;
      font-size: 4vw;
      margin: 5px 0;
    }
}
.box_ul{
    // margin: 8px;
.box_li{
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 40px;
    line-height: 40px;
    font-size: 3.7vw;
    font-weight: 450;
    border-bottom: 1px solid #f5f5f5;
    color: #666;

    .isAuditStatus{
    position: absolute;

    }
    .box_li_unit{
        font-size: 13px;
        color: #bbb;
    }
    .box_li_score{
     
     width: 62%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #1a1a1a;
    font-weight: 600;

    }
}

}
.buutom {
  padding: 10px;
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
  .button-on{
    width: 48%;
}
}
</style>
